import { useCallback } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { Flow } from 'core/flow/entities';
import { getFunnelFlow } from 'core/funnel/store/selectors';
import { updateFlow } from '../store/actions';

export const useFlow = () => {
  const dispatch = useDispatch();
  const activeFlow = useSelector(getFunnelFlow);

  const doUpdateFlow = useCallback(
    (flow: Flow) => {
      dispatch(updateFlow(flow));
    },
    [dispatch],
  );

  return {
    updateFlow: doUpdateFlow,
    activeFlow,
  };
};
